export interface FaqItem {
  q: string;
  a: string;
}

export interface FaqCategory {
  category: string;
  items: FaqItem[];
}

// Контекстные вопросы для конкретных страниц — усиливают GEO (ИИ-выдачу)
// и дают каждой странице собственную FAQPage-разметку с прямыми ответами.
export const PAGE_FAQS: Record<string, FaqItem[]> = {
  "/svadba": [
    {
      q: "Можно ли провести свадьбу на крыше в Петербурге?",
      a: "Да. Ресторан «Паруса на крыше» проводит свадьбы на 6-м этаже Olympic Plaza (ул. Марата, 5) — от камерных ужинов на 10–20 гостей до банкетов на 300 человек. Доступна выездная регистрация на открытой террасе с панорамой 300° на центр города.",
    },
    {
      q: "Сколько стоит свадьба в ресторане «Паруса на крыше»?",
      a: "Камерная свадьба в VIP-зале — от 60 000 ₽ депозита, банкет на террасе — от 1 000 000 ₽, свадьба под ключ с полным закрытием ресторана до 300 гостей — от 2 000 000 ₽. Точную смету менеджер рассчитывает индивидуально под формат.",
    },
    {
      q: "Что входит в организацию свадьбы под ключ?",
      a: "Выездная регистрация, декор и цветы, авторское меню, свадебный торт, живая музыка, ведущий и DJ, фотозона и персональный менеджер. Мы берём на себя всю организацию — паре остаётся только наслаждаться своим днём.",
    },
    {
      q: "На сколько гостей рассчитан банкетный зал?",
      a: "До 300 гостей при полном закрытии ресторана. Для камерных свадеб подойдёт VIP-зал на 10–20 человек, для средних торжеств — застеклённый зал или открытая терраса с панорамным видом.",
    },
    {
      q: "Можно ли провести выездную регистрацию на крыше?",
      a: "Да, выездная регистрация проводится на открытой террасе с видом на крыши Петербурга, Невский проспект и купола церквей. Сезон террасы — с мая по октябрь в зависимости от погоды.",
    },
  ],
  "/den-rozhdeniya": [
    {
      q: "Какая скидка в день рождения в «Паруса на крыше»?",
      a: "Скидка 20% на весь счёт действует 7 дней до и 7 дней после дня рождения, при оплате наличными и независимо от суммы. При бронировании укажите, что у вас день рождения, и предъявите паспорт в ресторане.",
    },
    {
      q: "Что дарят имениннику?",
      a: "Скидку 20% на счёт, бонусную карту ресторана, кусочек торта от шеф-кондитера и персональное поздравление от команды — наш способ сделать ваш день особенным.",
    },
    {
      q: "Где отметить день рождения с видом на Петербург?",
      a: "В ресторане «Паруса на крыше» на 6-м этаже Olympic Plaza (ул. Марата, 5): панорама 300° на исторический центр, живая музыка, авторская кухня и скидка 20% имениннику.",
    },
    {
      q: "Можно ли отметить день рождения большой компанией?",
      a: "Да. Для компаний доступны отдельные зоны и банкетный формат до 300 гостей. Для групп от 6 человек рекомендуем бронировать заранее по телефону +7 (812) 991-10-90.",
    },
    {
      q: "Можно ли принести свой торт?",
      a: "Да, свой торт принести можно. За нарезку и подачу взимается небольшая плата — уточните сумму при бронировании.",
    },
  ],
  "/korporativ": [
    {
      q: "Можно ли провести корпоратив на крыше в Петербурге?",
      a: "Да. «Паруса на крыше» принимает корпоративы до 300 гостей с профессиональной сценой и звуком в центре города (ул. Марата, 5). Доступно полное закрытие ресторана в любой день недели.",
    },
    {
      q: "Сколько стоит корпоратив в ресторане?",
      a: "Полное закрытие ресторана — от 2 000 000 ₽ в будни; для меньших групп рассчитывается депозит от 2 500 ₽ на человека. Индивидуальную смету менеджер готовит под формат мероприятия.",
    },
    {
      q: "Что входит в корпоративное мероприятие?",
      a: "Индивидуальное меню, сцена и звуковое оборудование, зоны для нетворкинга, живая музыка или DJ и персональный менеджер. Организуем в том числе новогодние корпоративы под ключ.",
    },
    {
      q: "На сколько человек рассчитаны залы?",
      a: "До 300 гостей. Есть застеклённый зал, открытая терраса и VIP-зона — формат подбирается под размер команды и бюджет.",
    },
  ],
  "/romanticheskiy-uzhin": [
    {
      q: "Где организовать романтический ужин в Петербурге?",
      a: "Романтический ужин с панорамой 300° — в ресторане «Паруса на крыше» на 6-м этаже Olympic Plaza (ул. Марата, 5). Закаты над Невой, живая музыка и авторская кухня создают атмосферу для свидания.",
    },
    {
      q: "Можно ли заказать особое оформление для свидания?",
      a: "Да — по запросу готовим декор, цветы, комплимент от кухни и место у панорамного окна. Сообщите пожелания при бронировании, и мы подготовим всё заранее.",
    },
    {
      q: "В какое время самый красивый вид на закат?",
      a: "Самые эффектные закаты — за 1–1,5 часа до захода солнца. Менеджер подскажет оптимальное время брони под текущий сезон.",
    },
    {
      q: "Нужно ли бронировать столик заранее?",
      a: "Столик у панорамного окна лучше бронировать заранее, особенно в пятницу и субботу. Бронь — онлайн, по телефону +7 (812) 991-10-90 или во ВКонтакте @parusa_nakryshe.",
    },
  ],
  "/terrasa": [
    {
      q: "Когда работает летняя терраса?",
      a: "Открытая терраса работает в сезон — обычно с мая по октябрь в зависимости от погоды. Это 6-й этаж Olympic Plaza с панорамой 300° на исторический центр Петербурга.",
    },
    {
      q: "Нужно ли бронировать столик на террасе?",
      a: "Да, мест на террасе ограниченное количество, и в тёплые вечера они быстро разбираются — рекомендуем бронировать заранее онлайн или по телефону +7 (812) 991-10-90.",
    },
    {
      q: "Что делать, если на улице дождь?",
      a: "Рядом с террасой — застеклённый зал с панорамными окнами и живыми растениями, куда можно перейти при плохой погоде, сохранив вид на город.",
    },
  ],
  "/zhivaya-muzyka": [
    {
      q: "Когда в ресторане играет живая музыка?",
      a: "Живые выступления проходят регулярно — джаз, лаунж, акустика и тематические вечера. Актуальное расписание концертов публикуется на странице «Афиша».",
    },
    {
      q: "Нужен ли билет на концерты?",
      a: "Вход на большинство выступлений свободный при посещении ресторана. На отдельные события может действовать депозит — детали указаны в афише.",
    },
    {
      q: "Можно ли заказать живую музыку на банкет?",
      a: "Да, для банкетов и частных мероприятий мы подбираем артистов под формат — от джазового трио до кавер-группы и DJ.",
    },
  ],
  "/banket": [
    {
      q: "Какие мероприятия можно провести в «Паруса на крыше»?",
      a: "Свадьбы, дни рождения, корпоративы, юбилеи и частные банкеты — до 300 гостей с панорамой 300° на центр Петербурга. Организация под ключ на ул. Марата, 5.",
    },
    {
      q: "Какой минимальный депозит на банкет?",
      a: "От 2 500 ₽ на человека в любой зоне ресторана. Закрытие VIP-зала (до 10–12 гостей) — от 30 000 ₽ в будни, полное закрытие ресторана — от 2 000 000 ₽.",
    },
    {
      q: "Можно ли составить меню банкета самостоятельно?",
      a: "Да, на сайте есть конструктор банкетного меню: выбираете блюда из 130+ позиций, сразу видите расчёт стоимости и отправляете заявку менеджеру.",
    },
    {
      q: "Как заказать банкет?",
      a: "Оставьте заявку на странице «Банкет» или позвоните по телефону +7 (812) 991-10-90 — менеджер свяжется в течение часа и подготовит индивидуальное предложение.",
    },
  ],
  "/menu": [
    {
      q: "Какая кухня в ресторане «Паруса на крыше»?",
      a: "Авторская европейская кухня с элементами русской. Шеф-повар готовит из сезонных продуктов. Есть основное меню, бизнес-ланч, чайная и винная карты, а также детское меню.",
    },
    {
      q: "Есть ли бизнес-ланч?",
      a: "Да, бизнес-ланч доступен в будние дни. Актуальное меню бизнес-ланча можно скачать в разделе «Меню» на сайте.",
    },
    {
      q: "Есть ли вегетарианские и детские блюда?",
      a: "Да, в меню есть вегетарианские позиции и отдельное детское меню. Часть блюд повара адаптируют под диетические предпочтения — сообщите официанту при заказе.",
    },
    {
      q: "Можно ли посмотреть меню онлайн?",
      a: "Да, все меню — основное, винное, чайное, детское и бизнес-ланч — доступны для скачивания в формате PDF на странице «Меню».",
    },
  ],
};

export const FAQS: FaqCategory[] = [
  {
    category: "Бронирование и посещение",
    items: [
      {
        q: "Как забронировать столик в ресторане «Паруса на крыше»?",
        a: "Забронировать столик можно онлайн через кнопку «Забронировать» на сайте, по телефону +7 (812) 991-10-90 или через мессенджер ВКонтакте @parusa_nakryshe. Бронирование подтверждается сразу.",
      },
      {
        q: "Какой режим работы ресторана?",
        a: "Ресторан работает ежедневно: понедельник–четверг и воскресенье с 12:00 до 23:00, пятница и суббота — с 12:00 до 01:00 следующего дня.",
      },
      {
        q: "Нужна ли предоплата при бронировании?",
        a: "При обычном бронировании столика предоплата не требуется. Для банкетов и закрытых мероприятий бронирование подтверждается после внесения депозита.",
      },
      {
        q: "Как добраться до ресторана?",
        a: "Ресторан находится по адресу: Санкт-Петербург, ул. Марата, 5, 6 этаж бизнес-центра Olympic Plaza. Ближайшие станции метро — Маяковская и Достоевская, от каждой пешком 7–10 минут.",
      },
      {
        q: "Есть ли парковка рядом с рестораном?",
        a: "Да, рядом с Olympic Plaza есть платная парковка на ул. Марата. Также доступна парковка в самом здании.",
      },
    ],
  },
  {
    category: "День рождения и скидки",
    items: [
      {
        q: "Есть ли скидка в день рождения?",
        a: "Да! Мы дарим скидку 20% на весь счёт в течение 7 дней до и 7 дней после дня рождения. Акция действует при оплате счёта наличными, независимо от суммы. При бронировании укажите, что у вас день рождения.",
      },
      {
        q: "Что ещё получает именинник?",
        a: "В подарок: скидка 20% на счёт, бонусная карта ресторана, кусочек торта от шеф-кондитера и персональное поздравление от команды. Это наш способ сказать: ваш день рождения — особенный.",
      },
      {
        q: "Нужно ли заранее сообщать о дне рождения?",
        a: "Желательно сообщить при бронировании — тогда мы сможем подготовить всё заранее. Но если вы скажете уже в ресторане, мы постараемся сделать вечер запоминающимся.",
      },
    ],
  },
  {
    category: "Банкеты и мероприятия",
    items: [
      {
        q: "Можно ли провести свадьбу в ресторане?",
        a: "Да, мы проводим свадьбы — от камерных ужинов для 10–20 гостей до банкетов на 300 человек с живой музыкой и выездной регистрацией. Организуем всё под ключ: декор, меню, артисты, ведущий.",
      },
      {
        q: "Какова минимальная сумма для проведения банкета?",
        a: "Минимальный депозит в любой зоне ресторана — от 2 500 ₽ на человека. Полное закрытие VIP-зала (до 10–12 гостей) — от 30 000 ₽ в будни. Для точного расчёта оставьте заявку на странице «Банкет».",
      },
      {
        q: "Можно ли провести корпоратив на крыше?",
        a: "Конечно. У нас есть площадки до 300 гостей, профессиональная сцена и звуковое оборудование. Полное закрытие ресторана доступно в любой день — от 2 000 000 ₽ в будни.",
      },
      {
        q: "Как организовать мероприятие «под ключ»?",
        a: "Оставьте заявку на странице Банкет или позвоните по телефону +7 (812) 991-10-90. Наш менеджер свяжется с вами в течение часа, уточнит детали и подготовит индивидуальное предложение.",
      },
    ],
  },
  {
    category: "Меню и кухня",
    items: [
      {
        q: "Какая кухня в ресторане?",
        a: "Авторская европейская кухня с элементами русской. Шеф-повар создаёт меню из сезонных продуктов. Есть основное меню, бизнес-ланч, чайная и винная карты, а также детское меню.",
      },
      {
        q: "Есть ли бизнес-ланч?",
        a: "Да, бизнес-ланч доступен в будние дни. Актуальное меню можно скачать в разделе «Меню» на сайте.",
      },
      {
        q: "Есть ли вегетарианские блюда?",
        a: "В меню есть вегетарианские позиции. Наши повара также могут адаптировать часть блюд под ваши диетические предпочтения — сообщите официанту при заказе.",
      },
      {
        q: "Можно ли принести свой торт?",
        a: "Да, принести свой торт можно. За сервировку торта взимается небольшая плата за разрезание и подачу — уточните сумму при бронировании.",
      },
    ],
  },
  {
    category: "Обстановка и особенности",
    items: [
      {
        q: "На каком этаже находится ресторан и какой вид открывается?",
        a: "Ресторан расположен на 6-м этаже бизнес-центра Olympic Plaza. Открывается панорамный вид на 300° на крыши исторической части Петербурга, Невский проспект, Казанский собор и купола церквей.",
      },
      {
        q: "Есть ли в ресторане живая музыка?",
        a: "Да, в ресторане регулярно проходят живые выступления — джаз, лаунж, акустика и тематические вечера. Актуальное расписание событий на странице «Афиша».",
      },
      {
        q: "Есть ли открытая терраса?",
        a: "Да, у ресторана есть открытая терраса с видом на город. Терраса работает в сезон — обычно с мая по октябрь в зависимости от погоды.",
      },
      {
        q: "Есть ли подарочные сертификаты?",
        a: "Да! Подарочные сертификаты номиналом 3 000 ₽ и 5 000 ₽ доступны на странице «Сертификаты». Оплата онлайн, сертификат отправляется на email мгновенно.",
      },
    ],
  },
];
